import SearchTextField, { SearchTextFieldStyles } from "@aus/Widgets/WorkOrderHistory/WorkOrderSearchTextField";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import * as React from "react";

export const productErpNumberStyles: SearchTextFieldStyles = {};
const styles = productErpNumberStyles;

const OrderHistorySearchFieldProductErpNumber: React.FunctionComponent<WidgetProps> = () => {
    return (
        <SearchTextField
            styles={styles}
            parameterField="productErpNumber"
            label="Product"
            inputType="text"
            placeholder={translate("Enter keyword or item #")}
        />
    );
};

const widgetModule: WidgetModule = {
    component: OrderHistorySearchFieldProductErpNumber,
    definition: {
        group: "Order History",
        displayName: "Work Order Product ERP Number",
        allowedContexts: ["WorkOrderHistoryPage"] as any,
    },
};

export default widgetModule;
